import { render } from "./OurTeam.vue?vue&type=template&id=c9de8890&scoped=true"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"

import "./OurTeam.vue?vue&type=style&index=0&id=c9de8890&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9de8890"]])

export default __exports__